import ApiService from '@/services/api.service'


const OrdersService = {
    getAll( parameter) {          
        const requestData = {
            method: 'get',
            url: "/PhysiciansOrders/",
            headers: {
            },
            params: { 
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,          
                PageNumber : parameter.PageNumber,
                PatientCode : parameter.PatientCode,
                Status : parameter.Status
            }
        }     
        return ApiService.customRequest(requestData);         
    },

    get(id) {
        return ApiService.get(`/PhysiciansOrders/${id}`);
    },

    add(data){
        return ApiService.post(`/PhysiciansOrders`,data)
    },

    delete(id){
        return ApiService.delete(`/PhysiciansOrders/${id}`)
    },
    
    update(id,data){
        return ApiService.put(`/PhysiciansOrders/${id}`,data)
    },

    getMarsTimes(frequencyCode) {
        return ApiService.get(`/PhysiciansOrders/marsTimes/${encodeURIComponent(frequencyCode)}`);
    },

    getOrdersSetup(Code) {
        return ApiService.get(`/PhysiciansOrders/OrdersSetup/${encodeURIComponent(Code)}`);
    },

    CopyOrder(data){
        return ApiService.post(`/PhysiciansOrders/CopyOrder`,data)
    },

    InactiveOrders(data){
        return ApiService.post(`/PhysiciansOrders/InactiveOrders`,data)
    },

    getPhysiciansOrdersOptions() {
        return ApiService.get(`/PhysiciansOrders/Options`);
    },

    getOrderType() {
        return ApiService.get(`/PhysiciansOrders/OrderType`);
    },

    IsCurrentOrder(parameter){
        const params = {      
            PatientCode:parameter.PatientCode,
            OrderCode:parameter.OrderCode,
            Mode:parameter.Mode,
            RecordId:parameter.RecordId,
            Action:parameter.Action,
            StartDateTime:parameter.StartDateTime,
            EndDateTime:parameter.EndDateTime,
            Day:parameter.Day 
        }
        return ApiService.getWithArray('/PhysiciansOrders/IsCurrentOrder',params); 
    },
}

export default OrdersService;